var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 50,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#220848"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 19.0013H15.14L18.77 14.6413C18.9397 14.437 19.0214 14.1738 18.997 13.9093C18.9726 13.6449 18.8442 13.401 18.64 13.2313C18.4358 13.0615 18.1725 12.9799 17.9081 13.0042C17.6437 13.0286 17.3997 13.157 17.23 13.3613L12.23 19.3613C12.1964 19.409 12.1663 19.4591 12.14 19.5113C12.14 19.5613 12.14 19.5913 12.07 19.6413C12.0247 19.7559 12.0009 19.878 12 20.0013C12.0009 20.1245 12.0247 20.2466 12.07 20.3613C12.07 20.4113 12.07 20.4413 12.14 20.4913C12.1663 20.5434 12.1964 20.5935 12.23 20.6413L17.23 26.6413C17.324 26.7541 17.4418 26.8449 17.5748 26.9071C17.7079 26.9694 17.8531 27.0015 18 27.0013C18.2337 27.0017 18.4601 26.9203 18.64 26.7713C18.7413 26.6873 18.825 26.5842 18.8863 26.4679C18.9477 26.3515 18.9855 26.2242 18.9975 26.0932C19.0096 25.9622 18.9957 25.8302 18.9567 25.7046C18.9176 25.579 18.8542 25.4623 18.77 25.3613L15.14 21.0013H27C27.2652 21.0013 27.5196 20.8959 27.7071 20.7084C27.8946 20.5208 28 20.2665 28 20.0013C28 19.736 27.8946 19.4817 27.7071 19.2941C27.5196 19.1066 27.2652 19.0013 27 19.0013Z",
    fill: "url(#paint0_linear_5123_33370)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5123_33370",
    x1: 20,
    y1: 13,
    x2: 20,
    y2: 27.0013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA6FFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#711CF1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBlue);
export default __webpack_public_path__ + "static/media/back-blue.b2e18522709609986504dae9aeb0f6d5.svg";
export { ForwardRef as ReactComponent };